$(document).ready(function () {
	if ($('.media-gallery-box').length && $('.media-gallery-box').hasClass('news')) {
		var mediaGallerySwiper = new Swiper('.media-gallery-box', {
			autoplay: 3000,
			nextButton: $('.media-gallery-box .swiper-button-next'),
			prevButton: $('.media-gallery-box .swiper-button-prev'),
			loop: true,
			slidesPerView: 1,
			breakpoints: {
				768: {
					slidesPerView: 1,
					spaceBetween: 0
				},
				1200: {
					slidesPerView: 3,
					spaceBetween: 19
				},
				1600: {
					slidesPerView: 3,
					spaceBetween: 19
				},
				3600: {
					slidesPerView: 3,
					spaceBetween: 19
				}
			}
		})
	} else {
		if ($('.media-gallery-box').length) {
			var mediaGallerySwiper = new Swiper('.media-gallery-box', {
				autoplay: 3000,
				nextButton: $('.media-gallery-box .swiper-button-next'),
				prevButton: $('.media-gallery-box .swiper-button-prev'),
				loop: true,
				slidesPerView: 1,
				breakpoints: {
					768: {
						slidesPerView: 1,
						spaceBetween: 0
					},
					1200: {
						slidesPerView: 3,
						spaceBetween: 19
					},
					1600: {
						slidesPerView: 4,
						spaceBetween: 19
					},
					3600: {
						slidesPerView: 5,
						spaceBetween: 19
					}
				}
			})

		}
	}
	if ($('.media-gallery-box').length) {
		var slide = 0
		$('.media-gallery-box .swiper-slide').each(function () {
			slide++
		})
		var mediaGalleryLightboxSwiper = new Swiper('.media-gallery-lightbox', {
			nextButton: $('.media-gallery-lightbox .swiper-button-next'),
			prevButton: $('.media-gallery-lightbox .swiper-button-prev'),
			slidesPerView: "auto",
			loopedSlides: slide,
			width: $(window).width(),
			autoHeight: true,
			centeredSlides: true
		})
		$('.media-gallery-box').on('click tap', '.swiper-slide', function () {
			var index = parseInt($(this).data('index'))
			$('#media-gallery-lightbox').addClass('open')
			mediaGalleryLightboxSwiper.slideTo(index, 300, true)
		})
		$(window).resize(function() {
			mediaGalleryLightboxSwiper.update(true)
			mediaGallerySwiper.update(true)
		})

		$('#media-gallery-lightbox').on('click tap', function (e) {
			if (e.target.id == $(this).attr('id')) {
				$('#media-gallery-lightbox').removeClass('open')
			}
		})
	}

})



//////////////////
// WEBPACK FOOTER
// ./assets/js/partials/_products.js
// module id = 15
// module chunks = 0